import { render } from "./PasswordBox.vue?vue&type=template&id=1d024ae7"
import script from "./PasswordBox.vue?vue&type=script&lang=ts"
export * from "./PasswordBox.vue?vue&type=script&lang=ts"
script.render = render

export default script